import { render, staticRenderFns } from "./recovery.vue?vue&type=template&id=14da9a18&scoped=true&"
import script from "./recovery.vue?vue&type=script&lang=js&"
export * from "./recovery.vue?vue&type=script&lang=js&"
import style0 from "./recovery.vue?vue&type=style&index=0&id=14da9a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14da9a18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
